<template>
  <ModalBase show-modal auto-h narrow @close-modal="close" class="gk-modal-invoice-payments">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          {{ $gettext('Invoice payments') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>

      <!-- Payment add form -->
      <div class="d-flex flex-column mb-3" style="padding-bottom: 1rem;">
        <div>
          <h4>{{ $gettext('Add Payment') }}</h4>
        </div>
        <b-form-group id="input-group-amount" label-class="gk-label-margin gk-modal-label" :label="$gettext('Payment total')" label-for="input-amount">
          <b-form-input id="input-amount" v-model="newPayment.amount" />
          <div class="gk-input-error">
            {{ newPayment.errors.paymentAmount }}
          </div>
        </b-form-group>
        <b-form-group id="input-group-type" label-class="gk-label-margin gk-modal-label" :label="$gettext('Payment type')" label-for="input-type">
          <b-form-select v-model="newPayment.payment_type" :options="paymentTypeOptions" />
          <div class="gk-input-error">
            {{ newPayment.errors.payment_type }}
          </div>
          <div v-if="newPayment.payment_type === 'bank'" class="text-right">
            <GekkoButton
              :to="{ name: 'Bank' }"
              :text="$gettext('Link to existing transaction?')"
              icon="fa-solid fa-arrow-up-right-from-square"
              icon-right
              variant="link"
              size="sm"
            />
          </div>
        </b-form-group>
        <b-form-group id="input-group-date" label-class="gk-label-margin gk-modal-label" :label="$gettext('Payment date')" label-for="input-date">
            <b-form-datepicker id="input-date" class="inline-form-datepicker" v-model="newPayment.payment_date" no-flip initial-date="2021-01-01"
                                :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" />
        </b-form-group>
        <b-form-group id="input-group-description" label-class="gk-label-margin gk-modal-label" :label="$gettext('Description')" label-for="input-description">
          <b-form-input data-analytics-click id="input-description" v-model="newPayment.description" />
        </b-form-group>
      </div>


      
    </template>
    <template v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
      />
      <GekkoButton
        @click="$emit('add-payment', false)"
        :text="$gettext('Register payment')"
        :variant="'primary'"
      />
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase"
import TitleBar from "@/components/TitleBar"
import GekkoButton from "@/components/GekkoButton"

export default {
  name: 'InvoicePaymentsModal',

  components: { 
    ModalBase,
    TitleBar,
    GekkoButton
  },
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      paymentTypeOptions: [
        { value: '', text: this.$gettext('Select a payment type') },
        { value: 'cash', text: this.$gettext('Cash or private account') },
        { value: 'bank', text: this.$gettext('Bank transaction') }
      ],
    }
  },
  computed: {
    newPayment: {
      get () { return this.value },
      set (newPayment) { this.$emit('input', newPayment) }
    },
  },
  watch: {

  },
  created () {
    this.setupData()
  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {

    },
  }
}
</script>

<style lang="scss">
.gk-modal-invoice-payments {
  .gk-modal {
    max-width: 530px !important;
    .invoice-section--label {
      font-size: 1rem;
    }
    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>